export default "__VITE_ASSET__DzrnR9OJ__"